import script from "./AntragfragenForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AntragfragenForm.vue?vue&type=script&setup=true&lang=js"

import "./AntragfragenForm.vue?vue&type=style&index=0&id=7723e74f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7723e74f"]])

export default __exports__